import Card from "@components/Card";
import { useAuthContext } from "@contexts/auth";
import { cardTexts } from "@utils/cardTexts";
import { formatDateDMY, formatDateMY } from "@utils/formatDate";
import { formatNumberToCurrency, formatNumberToLocale } from "@utils/formatNumber";

const { useProjectContext } = require("@contexts/projects");

const BasicInfo = () => {
  const { activeProject } = useProjectContext();

  const { user: { configurations: { mainCards } } } = useAuthContext();

  const checkCard = (i) => {
    switch (i) {
      case 'startDate':
        return <Card label='Data de Início' content={formatDateDMY(activeProject?.start_date) ?? "-"} tooltip={cardTexts.BUILDING_START} />
      case 'endDate':
        return <Card label='Data de Término' content={activeProject?.prediction_of_the_end ? formatDateDMY(activeProject?.prediction_of_the_end) : formatDateDMY(activeProject?.end_date)} subcontent={`Previsão original: ${activeProject?.end_date ? formatDateDMY(activeProject?.end_date) : '-'}`} tooltip={cardTexts.BUILDING_PREVISION} />
      case 'indexer':
        return <Card label={`${activeProject.indexer?.description} - ${activeProject.indexer?.type} (R$)`}
          content={`${formatNumberToCurrency(activeProject?.indexer?.value, false)} - ${formatDateMY(activeProject?.indexer?.date_used_in)}`}
          subcontent={`Valor original: ${formatNumberToCurrency(activeProject?.originalIndexer?.value, false)} - ${formatDateMY(activeProject?.originalIndexer?.date_used_in)}`}
          tooltip={cardTexts.CUB}
        />
      case 'area':
        return <Card label='Área construida (M²)' content={formatNumberToLocale(activeProject.area)} tooltip={cardTexts.AREA} />

      default:
        break;
    }
  }

  return (
    <div className="grid gap-24 columns-2-tablet columns-4-laptop-l">
      {(mainCards ?? []).map(i => {
        return checkCard(i)
      })}
    </div>
  );
};

export default BasicInfo;
